import { A2APaymentModule } from '@/components/modules/SinglePayment/A2APayment/A2APayment';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_A2A_PAYMENT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.A2A_PAYMENT,
  showIfAllowedProduct: ApplicationType.CARD_PAYMENT,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'A2A_PAYMENT_DETAIL',
      widgets: [
        {
          id: WIDGETS.LOAN_PAGE_TITLE,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'SUMMARY',
      module: (
        <A2APaymentModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
